const getDocument = (db, _id) =>
  db
    .get(`${_id}?t=${Date.now()}`)
    .then(({ data }) => data)

export default getDocument



// WEBPACK FOOTER //
// ./src/helpers/databases/getDocument.js